
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[slug]",
      function () {
        return require("private-next-pages/store/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[slug]"])
      });
    }
  